var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1663",
    "data-name": "Group 1663",
    transform: "translate(-929 -916.933)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_571",
    "data-name": "Rectangle 571",
    width: 22,
    height: 22,
    transform: "translate(929 916.933)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_01_align_center",
    "data-name": " 01 align center",
    transform: "translate(-6176.479 -4283.709)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_301",
    "data-name": "Path 301",
    d: "M7124.479,5211.642a7.963,7.963,0,0,0-1.9-5.16l.573-.574-.943-.942-.574.573a7.968,7.968,0,0,0-10.321,0l-.573-.573-.942.943.573.573a7.971,7.971,0,0,0,0,10.322l-.573.573.943.942.573-.573a7.971,7.971,0,0,0,10.322,0l.573.573.942-.943-.573-.574A7.96,7.96,0,0,0,7124.479,5211.642Zm-1.333,0a6.636,6.636,0,0,1-1.508,4.216l-2.381-2.38a3.308,3.308,0,0,0,0-3.671l2.381-2.381A6.639,6.639,0,0,1,7123.146,5211.642Zm-8.667,0a2,2,0,1,1,2,2A2,2,0,0,1,7114.479,5211.642Zm2-6.666a6.627,6.627,0,0,1,4.216,1.508l-2.38,2.38a3.313,3.313,0,0,0-3.671,0l-2.381-2.38A6.629,6.629,0,0,1,7116.479,5204.976Zm-6.666,6.666a6.628,6.628,0,0,1,1.508-4.216l2.38,2.381a3.312,3.312,0,0,0,0,3.671l-2.38,2.38A6.625,6.625,0,0,1,7109.813,5211.642Zm6.666,6.667a6.635,6.635,0,0,1-4.216-1.508l2.381-2.381a3.308,3.308,0,0,0,3.671,0l2.38,2.381A6.633,6.633,0,0,1,7116.479,5218.309Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSupport);
export default __webpack_public_path__ + "static/media/icon-support.aaa2a55749c53930972fb88ec3dd40ed.svg";
export { ForwardRef as ReactComponent };